module.exports = __webpack_public_path__ + "img/003-twitter.dd90206d.svg";